import Application from '../Application';
import BakedModel from '../Utils/BakedModel';
export default class Computer {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        this.bakeModel();
        this.setModel();
        this.removeHeffernanText();
    }
    bakeModel() {
        this.bakedModel = new BakedModel(this.resources.items.gltfModel.computerSetupModel, this.resources.items.texture.computerSetupTexture, 900);
    }
    setModel() {
        this.scene.add(this.bakedModel.getModel());
    }
    /**
     * Traverse the loaded GLB scene and hide any mesh/object whose
     * name contains "Heffernan" (case-insensitive). The original Henry
     * Heffernan portfolio has a text geometry on the monitor bezel with
     * that name — we hide it rather than deleting it so Three.js doesn't
     * complain about missing references.
     */
    removeHeffernanText() {
        this.bakedModel.getModel().traverse((child) => {
            if (child.name) {
                const n = child.name.toLowerCase();
                if (n.includes('heffernan') || n.includes('henry') || n.includes('text')) {
                    child.visible = false;
                }
            }
        });
    }
}
